module.exports = __webpack_public_path__ + "assets/img/service.18bda82e.png";